import * as Errors from '../errors';
import type { IErrorInfo } from '../errors/errorInfo';
import type { IErrorResponse } from '../errors/errorInfo';

export type { IErrorInfo, IErrorResponse };

export const errorInfo = Errors.errorInfo;

export const shortErrorInfo = Errors.shortErrorInfo;
